export class ShuttlePanelSlide {
}
//# sourceMappingURL=shuttle-panel-slide.js.map